import { useEffect, useState } from 'react';
import { usePWA } from './PWAContext';
import './PWAInstallPrompt.css';

import conti from '../imagesHome/conti.png'

const DISMISSED_AT_KEY = 'contalearn_pwa_prompt_dismissed_at';
const DISMISS_COUNT_KEY = 'contalearn_pwa_prompt_dismiss_count';

const SHOW_AFTER_MS = 3 * 60 * 1000; // 3 minute
const REMIND_AFTER_DAYS = 30;
const MAX_AUTO_DISMISSALS = 2;

const PWAInstallPrompt = () => {
  const {
    isStandalone,
    canInstall,
    isIOS,
    installApp
  } = usePWA();

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Daca aplicatia ruleaza deja ca PWA,
    // nu afisam popup-ul.
    if (isStandalone) {
      setShowPopup(false);
      return;
    }

    // Pe Android / Chrome / Edge asteptam ca browserul
    // sa confirme ca instalarea este disponibila.
    //
    // Pe iOS putem afisa instructiunile manual,
    // deoarece nu exista beforeinstallprompt.
    if (!canInstall && !isIOS) {
      setShowPopup(false);
      return;
    }

    const dismissCount = Number(
      localStorage.getItem(DISMISS_COUNT_KEY) || '0'
    );

    // Daca utilizatorul a refuzat deja de doua ori,
    // nu mai afisam automat popup-ul.
    if (dismissCount >= MAX_AUTO_DISMISSALS) {
      setShowPopup(false);
      return;
    }

    const dismissedAt = Number(
      localStorage.getItem(DISMISSED_AT_KEY) || '0'
    );

    // Daca popup-ul a fost inchis anterior,
    // asteptam 30 de zile pana il putem afisa din nou.
    if (dismissedAt > 0) {
      const remindAfterMs =
        REMIND_AFTER_DAYS * 24 * 60 * 60 * 1000;

      const elapsed = Date.now() - dismissedAt;

      if (elapsed < remindAfterMs) {
        setShowPopup(false);
        return;
      }
    }

    // Afisam popup-ul dupa 3 minute.
    const timer = window.setTimeout(() => {
      setShowPopup(true);
    }, SHOW_AFTER_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, [isStandalone, canInstall, isIOS]);

  const rememberDismissal = () => {
    const currentCount = Number(
      localStorage.getItem(DISMISS_COUNT_KEY) || '0'
    );

    localStorage.setItem(
      DISMISSED_AT_KEY,
      String(Date.now())
    );

    localStorage.setItem(
      DISMISS_COUNT_KEY,
      String(currentCount + 1)
    );
  };

  const handleClose = () => {
    rememberDismissal();
    setShowPopup(false);
  };

  const handleInstall = async () => {
    const result = await installApp();

    if (!result.available) {
      setShowPopup(false);
      return;
    }

    if (result.outcome === 'accepted') {
      localStorage.removeItem(DISMISSED_AT_KEY);
      localStorage.removeItem(DISMISS_COUNT_KEY);

      setShowPopup(false);
      return;
    }

    if (result.outcome === 'dismissed') {
      rememberDismissal();
      setShowPopup(false);
    }
  };

  if (!showPopup) {
    return null;
  }

  return (
    <div className="pwa-install-overlay">
      <div className="pwa-install-popup">

        <button
          type="button"
          className="pwa-install-close"
          onClick={handleClose}
          aria-label="Închide"
        >
          ×
        </button>

      <div className="pwa-install-icon">
  <img
    src={conti}
    alt="ContaLearn"
    className="pwa-install-icon-image"
  />
</div>

        <h2>Instalează ContaLearn</h2>

        {isIOS ? (
          <>
            <p>
              Adaugă ContaLearn pe ecranul principal pentru
              acces mai rapid la cursurile tale.
            </p>

            <div className="pwa-ios-instructions">
              Apasă <strong>Partajează</strong>, apoi selectează
              <strong> „Adaugă la ecranul principal”</strong>.
            </div>

            <button
              type="button"
              className="pwa-install-later"
              onClick={handleClose}
            >
              Continuă în browser
            </button>
          </>
        ) : (
          <>
            <p>
              Instalează aplicația ContaLearn pentru acces
              rapid direct de pe dispozitivul tău.
            </p>

            <button
              type="button"
              className="pwa-install-button"
              onClick={handleInstall}
            >
              Instalează aplicația
            </button>

            <button
              type="button"
              className="pwa-install-later"
              onClick={handleClose}
            >
              Continuă în browser
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default PWAInstallPrompt;